import createReducer from '../createReducer';
import {
  FETCH_PAGE,
  FETCH_PAGE_SUCCESS,
  FETCH_PAGE_FAILURE,
} from '../../actions/cms/pages';

const initialState = {
  loading: false,
  pages: {},
};

const handlers = {};

handlers[FETCH_PAGE] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_PAGE_SUCCESS] = (state, page) => ({
  ...state,
  loading: false,
  pages: {
    ...page,
  },
});

handlers[FETCH_PAGE_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/cms/pages.js